import React, {useEffect, useState} from 'react';
import {Button, Form} from "react-bootstrap";
import FormGroup from "../components/formGroup";
import MySelect from "../components/form/mySelect";
import {useForm, Controller} from "react-hook-form";
import MyCard from "../components/myCard";
import screens from "../screens";
import {Get} from "../components/request";
import {isObject} from "lodash";
import FormCheckbox from "../components/form/formCheckbox";
import FormSelect from "../components/form/formSelect";

function DonneesIDM(props: { onSubmit: Function, parameters: Object }) {
    const {register, control, handleSubmit, formState, setValue, getValues} = useForm();

    const onSubmit = data => props.onSubmit(data);

    let [memoire, updateMemoire] = useState({});

    useEffect(() => {
        const fetch = async () => {
            const {body} = await Get(`/v1/extranet/student/${screens.Memoire}`);
            updateMemoire(body);
        }

        fetch();
    }, [updateMemoire])

    useEffect(() => {
        setValue("AdresseStageMemoireOrganisation", memoire.AdresseStageMemoireOrganisation || "");
        setValue("AdresseStageMemoireNomRepresentant", memoire.AdresseStageMemoireNomRepresentant || "");
        setValue("AdresseStageMemoirePrenomRepresentant", memoire.AdresseStageMemoirePrenomRepresentant || "");
        setValue("AdresseStageMemoireEmailRepresentant", memoire.AdresseStageMemoireEmailRepresentant || "");
        setValue("AdresseStageMemoireTelephoneRepresentant", memoire.AdresseStageMemoireTelephoneRepresentant || "");
    }, [memoire, setValue]);


    const ZoneMemoire = (
        <>
            {/*
            ** V1
            Champ qui permet de récupérer & afficher la valeur session déjà enregistrée en BDD lors du dépot données mémoire.
            <FormGroup
                label={"Choix session"}
                name={"SessionID"}
                //defaultValue={props.parameters.SessionID.filter(f => f.value === memoire.SessionID).map(m => m.label)}
            />
            */}
            {/*
            V2
            ** Champ qui permet d'afficher toutes les sessions et d'enregistrer le choix.
          <Controller name={"SessionID"}
                        value={getValues("SessionID") !== undefined ? (isObject(getValues("SessionID"))
                            ? getValues("SessionID").value
                            : props.parameters.SessionID.find(f => f.value === getValues("SessionID").value)) : undefined}
                        rules={{required: true}}
                        render={({field}) => <FormGroup
                            {...field}
                            errors={formState.errors.SessionID}
                            required={true}
                            label={"Première session de défense"}
                            type={MySelect}
                            options={props.parameters.SessionID}
                        />}
                        control={control}/>
            */}
            <Controller name={"SessionID"}
                        value={getValues("SessionID") !== undefined ? (isObject(getValues("SessionID"))
                            ? getValues("SessionID").value
                            : props.parameters.SessionID.find(f => f.value === getValues("SessionID").value)) : undefined}
                        rules={{required: true}}
                        render={({field}) => <FormGroup
                            {...field}
                            errors={formState.errors.SessionID}
                            required={true}
                            label={"Session de défense"}
                            type={MySelect}
                            options={props.parameters.SessionAAActiveID}
                            /*  options={props.parameters.SessionAAActiveID.filter((f) =>
                                f.label.includes("Septembre") || f.label.includes("Juin"))}  */
                        />}
                        control={control}/>

            <FormGroup label={"Titre provisoire du mémoire"}
                       name={"MemoireTitre"}
                       as={"textarea"}
                       value={memoire.MemoireTitre !== null && memoire.MemoireTitre}
                       disabled={true}
            />

            <b> Si vous désirez modifier le titre provisoire initial, veuillez entrer le nouveau titre provisoire
                ici </b>
            <FormGroup label={"Titre provisoire modifié du mémoire"}
                       as={"textarea"}
                       {...register("MemoireTitreModification", {required: false, maxLength: 1000})}
            />

            <FormGroup label={"Promoteur"}
                       name={"MembrePersonnelID"}
                       disabled={true}
                       defaultValue={props.parameters.MembrePersonnelID.filter(f => f.value === memoire.MembrePersonnelID).map(m => m.label)}
            />


            {props.parameters.StatutConfidentialiteID.filter(f => f.value === memoire.StatutConfidentialiteID).map(m => m.label) == "Confidentialité acceptée"
            ?
                (
            <FormGroup label={"Statut Confidentialité"}
                       name={"StatutConfidentialiteID"}
                       disabled={true}
                       defaultValue={props.parameters.StatutConfidentialiteID.filter(f => f.value === memoire.StatutConfidentialiteID).map(m => m.label)}
            />
                )
            :
                (
            <Controller name={"StatutConfidentialiteID"}
                        value={getValues("StatutConfidentialiteAffichageID") !== undefined ? (isObject(getValues("StatutConfidentialiteAffichageID"))
                            ? getValues("StatutConfidentialiteAffichageID").value
                            : props.parameters.StatutConfidentialiteAffichageID.find(f => f.value === getValues("StatutConfidentialiteAffichageID").value)) : undefined}
                        rules={{required: true}}
                        render={
                            ({field}) =>
                                <FormGroup
                                    {...field}
                                    errors={formState.errors.StatutConfidentialiteAffichageID}
                                    required={true}
                                    label={"Statut Confidentialité"}
                                    type={MySelect}
                                    options={props.parameters.StatutConfidentialiteAffichageID}
                                />
                        }
                        control={control}
            />
                )
        }

            <Controller name={"LangueMemoireID"}
                        value={getValues("LangueMemoireID") !== undefined ? (isObject(getValues("LangueMemoireID"))
                            ? getValues("LangueMemoireID").value
                            : props.parameters.LangueMemoireID.find(f => f.value === getValues("LangueMemoireID").value)) : undefined}
                        rules={{required: true}}
                        render={({field}) => <FormGroup
                            {...field}
                            errors={formState.errors.LangueMemoireID}
                            required={true}
                            label={"Langue de rédaction"}
                            type={MySelect}
                            options={props.parameters.LangueMemoireID}
                        />}
                        control={control}
            />

            <FormGroup name={"LangueDefenseID"}
                       label={"Langue de défense"}
                       type={FormSelect}
                       control={control}
                       required={true}
                       options={props.parameters.LangueDefenseID}
            />

            <FormGroup label={"Veuillez indiquer vos examens : Code cours , horaire, intitulé ; allez à la ligne entre deux examens"}
                       as={"textarea"}
                       required={true}
                       {...register("MemoireDatesExamensEtudiant", {required: true})}
            />

            <FormGroup
                name={"MemoireEntrepriseFamiliale"}
                label={"Mémoire en lien avec l'entreprise familiale"}
                type={FormCheckbox}
                control={control}
                onChange={d => {
                    setValue("MemoireEntrepriseFamiliale", d);
                }}
            />

            <FormGroup label={"Mots-clés"}
                       as={"textarea"}
                       required={true}
                       {...register("MemoireMotsClefs", {required: true})}
            />

            <b> Votre résumé doit contenir entre 1000 et 8000 caractères (et pas "mots").
                Une fois la limite de 8000 atteinte, la zone n'acceptera plus de caractères supplémentaires.
                <a href="http://compteur-de-caracteres.com/"
                   target="_blank"
                   rel="noopener noreferrer"> Vérifiez vos caractères via ce lien.
                </a></b>

            <FormGroup label={"Résumé du mémoire"}
                       as={"textarea"}
                       required={true}
                       minLength={1000}
                       maxLength={8000}
                       rows={10}
                       {...register("MemoireResume", {required: true, minLength: 1000, maxLength: 8000})}
            />
        </>
    );

    const ZoneMaitreStage = (
        <>
            <p>
                <b>
                    La personne qui vous a réellement accompagné(e) lors de votre stage et qui sera présente à votre
                    défense de mémoire.
                </b>
            </p>
            <FormGroup label={"Organisation"}
                    {...register("AdresseStageMemoireOrganisation", { maxLength: 100 })}
                    defaultValue={memoire.AdresseStageMemoireOrganisation || ""}
                    className="form-control"
                />

            <FormGroup label={"Nom du maître de stage"}
                       {...register("AdresseStageMemoireNomRepresentant", {maxLength: 100})}
                       defaultValue={memoire.AdresseStageMemoireNomRepresentant || ""}
                       className="form-control"
            />

            <FormGroup label={"Prénom du maître de stage"}
                       {...register("AdresseStageMemoirePrenomRepresentant", {maxLength: 100})}
                       defaultValue={memoire.AdresseStageMemoirePrenomRepresentant || ""}
                       className="form-control"
            />

            <FormGroup label={"Email du maître de stage"}
                       type={"email"}
                       {...register("AdresseStageMemoireEmailRepresentant", {
                           maxLength: 100,
                           pattern: /^\S+@\S+$/i
                       })}
                       defaultValue={memoire.AdresseStageMemoireEmailRepresentant || ""}
                       className="form-control"
            />

            <FormGroup label={"Téléphone du maître de stage"}
                       type={"tel"}
                       {...register("AdresseStageMemoireTelephoneRepresentant", {minLength: 6, maxLength: 18})}
                       defaultValue={memoire.AdresseStageMemoireTelephoneRepresentant || ""}
                       className="form-control"
            />
        </>
    );
    return (
        <Form noValidate validated={(formState.isSubmitting || formState.isSubmitted) && !formState.isValid}
              onSubmit={handleSubmit(onSubmit)}>

            <MyCard header={"Informations mémoire"}
                    body={ZoneMemoire}/>
            <br/>

            <MyCard header={"Maître de stage"}
                    body={ZoneMaitreStage}/>
            <br/>

            <Button type="submit" variant="success" size={"lg"} block>
                Sauvegarder
            </Button>

        </Form>
    );
}
export default DonneesIDM;